// 에이전트가 내놓은 SQL 한 덩이 — 편집기 삽입·실행·실행계획·복사.
// 실행은 활성 탭에 세션이 바인딩돼 있어야 가능하다(App.js proceedWithExecution 의 전제).
import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { FiCornerUpLeft, FiPlay, FiBarChart2, FiCopy } from 'react-icons/fi';
import styles from './AssistantPanel.module.css';

function SqlBlock({ sql, rationale, canRun, canExplain, onInsert, onRun, onExplain, onCopy }) {
    const { t } = useTranslation();
    return (
        <div className={styles.sqlBlock}>
            <div className={styles.sqlBar}>
                <span className={styles.sqlBarLabel}>SQL</span>
                <button type="button" className={styles.smallBtn} onClick={() => onInsert(sql)} title={t('assistant:sql.insertHint')}>
                    <FiCornerUpLeft size={11} /> {t('assistant:sql.insert')}
                </button>
                <button
                    type="button"
                    className={styles.smallBtn}
                    onClick={() => onRun(sql)}
                    disabled={!canRun}
                    title={canRun ? t('assistant:sql.runHint') : t('assistant:sql.needSession')}
                >
                    <FiPlay size={11} /> {t('assistant:sql.run')}
                </button>
                <button
                    type="button"
                    className={styles.smallBtn}
                    onClick={() => onExplain(sql)}
                    disabled={!canExplain}
                    title={canExplain ? t('assistant:sql.planHint') : t('assistant:sql.needConnection')}
                >
                    <FiBarChart2 size={11} /> {t('assistant:sql.plan')}
                </button>
                <button type="button" className={styles.smallBtn} onClick={() => onCopy(sql)} title={t('common:ui.copy')}>
                    <FiCopy size={11} />
                </button>
            </div>
            <pre className={styles.sqlCode}>{sql}</pre>
            {rationale ? <div className={styles.rationale}>{rationale}</div> : null}
        </div>
    );
}

SqlBlock.propTypes = {
    sql: PropTypes.string.isRequired,
    rationale: PropTypes.string,
    canRun: PropTypes.bool,
    canExplain: PropTypes.bool,
    onInsert: PropTypes.func.isRequired,
    onRun: PropTypes.func.isRequired,
    onExplain: PropTypes.func.isRequired,
    onCopy: PropTypes.func.isRequired,
};

export default SqlBlock;
